export const contactInfo = {
    mailTo: "mckeefrys.maghera@googlemail.com",
    phone: "028 7964 4367",
    
    page: "/page/contact",
    facebook: "https://www.facebook.com/McKeefrysFurniture/",
    instagram: "https://www.instagram.com/mckeefrysfurniture/?hl=en",
    twitter: "",
    pinterest: "",
    youtube: "",
    linkedin: ""
}

export const contactForm = {
    fields:
    {
        name: {
            required: false,
            showInput: true
        },
        email: {
            required: false,
            showInput: true
        },
        phone: {
            required: false,
            showInput: true
        },
        storeName: {
            required: false,
            showInput: false
        },
        message: {
            required: false,
            showInput: true
        },

    }
}

export const sendAMessage = {
    title: 'Contact',
    subtitle: 'Send Us a Message',
    description: 'Leave us a comment or ask us a question and we will get back to you as quickly as possible. Please, use the contact form.',
    callUs: {
        title: 'Call Us',
        subtitle: 'Our friendly and knowledgeable staff would be delighted to help you.',
    }
}

export const storeLocations = {
    title: 'Store Locations',
    subtitle: 'Take a visit to our showrooms in both Maghera & Ballymena where you can see a number of our products in situation!',
    where: {
        title: 'MAGHERA HQ',
        subtitle: '80-82a Main Street, Maghera BT46 5AF',
        urlMap: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4594.632766174082!2d-6.674065!3d54.844693!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x486043c9c6f52b19%3A0x82a375bbc389f683!2sMckeefrys%20Home%20Furnishing%20Superstores!5e0!3m2!1sen!2suk!4v1701457376100!5m2!1sen!2suk'
    },
    opening: {
        title: 'Opening Hours',
        subtitle: 'Monday-Friday  /  Saturday'
    }
}

export const  socialMediaMetadataInfo = {    
    urlImageSocial: '',
    urlTwitterImage: '',
}

export const showCaptcha = {
    visible: false,
    sitekey: "2ce7ad9b-d0ba-4b4a-b453-30dcdf4448ba", // (hcaptcha email= info@thewebsystem.com , password =BCEjzWCv_emg4R3)
    language: 'en'
}